import React from "react";
import { Modal } from "antd";
import EmailDealerForm from "./EmailDealerForm";
import Header from "./Header";
import styles from "./emailDealerModal.scss";
import HelmetComponent from "../../../../utils/HelmetHelper";
function EmailDealerModal(props: any) {
  const { isVisible, adId, closeModal, category, setVisible } = props;

  return (
    <Modal
      afterClose={closeModal}
      wrapClassName={styles.container}
      footer={null}
      closable={false}
      visible={isVisible}
      destroyOnClose
    >
      <HelmetComponent
        title={`${"Kontaktiraj oglašivača"} | ${"INDEX OGLASI"}`}
      />
      <Header onClose={closeModal} />
      <EmailDealerForm
        adId={adId}
        onCancel={closeModal}
        category={category}
        setVisible={setVisible}
      />
    </Modal>
  );
}

export default EmailDealerModal;



// WEBPACK FOOTER //
// ./src/containers/AdDetailsPage/AdDetailsPageMobile/EmailDealerModal/index.tsx